import McpConnectionsPage from './McpConnectionsPage';

const exports = {
    Page: McpConnectionsPage,
};
export default exports;
